import initial from "../store/initial.js";

function features(featureState = initial.features, action) {
  return featureState;
}

export default features;
